import Page from 'client/components/aria/Page/Page';
import { useIntl } from 'react-intl';
import { Breadcrumbs } from 'client/components/GDS/Breadcrumbs/Breadcrumbs';
import FeedbackForm from '../FeedbackForm/FeedbackForm';
import { HOME_PAGE } from 'client/utils/routes/routeConstants';
import { useState } from 'react';
import { useLoaderData } from 'react-router';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import Alert from 'client/components/aria/Alert/Alert';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';

const FeedbackPage = () => {
    const intl = useIntl();
    useLocaleAutoSwitch();
    const [feedbackAlert, setFeedbackAlert] = useState(false);
    const [feedbackSavedOk, setFeedbackSavedOk] = useState(true);
    const breadcrumbsData = [
        { name: intl.formatMessage({ id: 'navbar.link.home' }), link: HOME_PAGE },
        { name: intl.formatMessage({ id: 'feedbackPage.title' }), ariaCurrent: 'page' }
    ];

    const loaderData = useLoaderData() || {};
    const { feedbackDescription, feedbackFormConfirmation } = loaderData;
    return (
        <Page title={intl.formatMessage({ id: 'feedbackPage.title' })} data-testid="saveObservationPage">
            <div className="feedbackPage" data-testid="feedbackPage">
                <Breadcrumbs items={breadcrumbsData} />
                {feedbackAlert &&
                    <Alert
                        title={intl.formatMessage({ id: 'feedbackForm.success.title' })}
                        variant="success"
                        data-testid="feedbackForm.successAlert"
                    >
                        <Markdown>
                            {feedbackFormConfirmation?.markdown}
                        </Markdown>
                    </Alert>
                }
                {!feedbackSavedOk &&
                    <div>
                        <Alert
                            title={intl.formatMessage({ id: 'error' })}
                            variant="error"
                            data-testid="feedbackForm.errorAlert"
                        >
                            <div className="govuk-body govuk-!-font-size-19 govuk-!-font-weight-bold">
                                {intl.formatMessage({ id: 'feedbackPage.error.message' })}
                            </div>
                        </Alert>
                    </div>
                }
                <h1>{intl.formatMessage({ id: 'feedbackPage.title' })}</h1>
                <Markdown data-testid={'feedbackPage.cmsContent'}>
                    {feedbackDescription?.markdown}
                </Markdown>
                <hr/>
                <FeedbackForm setFeedbackAlert={setFeedbackAlert} feedbackAlert={feedbackAlert} setFeedbackSavedOk={setFeedbackSavedOk} />
            </div>
        </Page>
    );
};

export default FeedbackPage;
